import SectionHub from '@/components/docs/SectionHub';

export default function Docs01MarketDataETFsHub() {
  return <SectionHub sectionPath="01-market-data/ETFs" />;
}
